import { brandConfig } from '../../brand-config.js';

/**
 * Filters policy types based on the current brand's configuration
 *
 * @param {string[]} policyTypes - Array of policy type strings to filter
 * @returns {string[]} Filtered policy types that are allowed for the current brand
 */
export const filterPolicyTypesByBrand = (policyTypes) => {
  // If brand doesn't have allowedPolicyTypes config, return all policy types
  if (!brandConfig.allowedPolicyTypes) {
    return policyTypes;
  }

  // Filter policy types based on brand's allowed policy types
  return policyTypes.filter((policyType) => brandConfig.allowedPolicyTypes.includes(policyType));
};
